// Modules
import { reviewSliderInit } from './modules/review-slider';

window.addEventListener('DOMContentLoaded', () => {
  reviewSliderInit();
});